import { gettext } from '@eventbrite/i18n';
import { SocialLoginButtons } from '@eventbrite/social-login-facebook';
import React from 'react';
import { socialProviderClickAction } from '../../actions/social';
import {
    socialConnectVerifiedAction,
    socialLogInUserAuthorizedAction,
    socialLogInUserNotAuthorizedAction,
} from '../../actions/socialHandlers';
import { handleAcceptSocialToS } from '../../actions/tos';
import ToSDialog from '../../components/ToSDialog';
import { TOSMODAL_SOCIAL_DENIED } from '../../constants/analytics';
import { TOS_SOCIAL_MUST_BE_ACCEPTED } from '../../constants/tosMessages';
import {
    IConfigContextProps,
    useConfigContext,
} from '../../contexts/ConfigContext';
import { DisabledSocialOptions } from '../../contexts/ConfigContext/interfaces';
import {
    IFrontendContext,
    useFrontendContext,
} from '../../contexts/FrontendContext';
import {
    INotificationContext,
    useNotificationsContext,
} from '../../contexts/NotificationsContext';
import { IUserContext, useUserContext } from '../../contexts/UserContext';
import SocialOneTap from '../socialOneTap/SocialOneTap';

const SocialLoginOptions = ({
    routing,
    isSignupFlow,
}: {
    routing: any;
    isSignupFlow?: boolean;
}) => {
    const configContext: IConfigContextProps = useConfigContext();
    const userContext: IUserContext = useUserContext();
    const notificationsContext: INotificationContext =
        useNotificationsContext();
    const frontendContext: IFrontendContext = useFrontendContext();
    const secondarySocialMethods = configContext.social?.secondarySocialMethods;

    const contexts = {
        configContext,
        notificationsContext,
        userContext,
        frontendContext,
    };

    const onSocialProviderClick = (
        socialProvider: string,
        stateFromProvider: any,
        isOneTap = false,
    ) => {
        socialProviderClickAction({
            socialProvider,
            stateFromProvider,
            isOneTap,
            contexts,
        });
    };

    const onSocialLogInUserAuthorized = (
        socialProvider: string,
        // socialResponse: any,
    ) => {
        socialLogInUserAuthorizedAction({
            socialProvider,
            contexts,
        });
    };

    const onSocialConnectVerified = (
        socialProvider: string,
        socialResponse: any,
    ) => {
        socialConnectVerifiedAction({
            socialProvider,
            socialResponse,
            contexts,
        });
    };

    const onSocialConnectNotAuthorized = (
        socialProvider: string,
        socialResponse: any,
    ) => {
        socialLogInUserNotAuthorizedAction({
            socialProvider,
            socialData: socialResponse,
            contexts,
        });
    };

    const oneTapValue = DisabledSocialOptions.googleOneTap as const;

    return (
        <>
            <SocialLoginButtons
                buttonAppleText={gettext('Sign in with Apple')}
                buttonFBText={gettext('Sign in with Facebook')}
                buttonGoogleText={gettext('Sign in with Google')}
                asyncStrategy="async"
                // Actions
                handleSocialProviderClick={onSocialProviderClick}
                onSocialLogInUserAuthorized={onSocialLogInUserAuthorized}
                onSocialConnectVerified={onSocialConnectVerified}
                onSocialConnectNotAuthorized={onSocialConnectNotAuthorized}
                // Config
                socialSSOSettings={configContext.social?.SSOSettings}
                fp={configContext.fp}
                disabledOptions={configContext.social?.disabledOptions}
                secondarySocialMethods={secondarySocialMethods}
                isSignupFlow={isSignupFlow}
            />

            {!configContext.social?.disabledOptions?.includes(oneTapValue) && (
                <SocialOneTap />
            )}

            <ToSDialog
                dataTestId="signup-tos"
                cancelActionName={TOSMODAL_SOCIAL_DENIED}
                cancelNotificationMessage={TOS_SOCIAL_MUST_BE_ACCEPTED}
                routing={routing}
                handleAcceptToS={() =>
                    handleAcceptSocialToS({ contexts, routing })
                }
            />
        </>
    );
};

export default SocialLoginOptions;
